module.exports = __webpack_public_path__ + "static/media/why-drink.46f4dccc.png";